import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { loyaltyDomainStore } from '../../../store';
export const getMemberRewards = () => {
    return getFetchedDataPayload(loyaltyDomainStore.data.memberRewards);
};
